(function () {
    'use strict';

    angular
        .module('app')
        .controller('BookingCheckoutCompleteController', BookingCheckoutCompleteController);

    BookingCheckoutCompleteController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies'];

    function BookingCheckoutCompleteController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;

        function init() {
        }
        
        function close() {
            return $state.go('frontpage');
        }

    }
})();